<div
  *ngIf="mainImg"
  style="display: flex; justify-content: center; background-color: #000000a4"
>
  <img
    matRipple
    (click)="fnZoom(mainImg)"
    src="{{ mainImg }}"
    style="object-fit: contain; height: 390px; width: 636px"
  />
</div>

<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  style="background-color: #000000a4"
>
  <div fxFlex="100%" fxLayout="row" fxLayoutAlign="center center">
    <div
      style="padding: 2px; background-color: #000000c5; height: 58px"
      *ngFor="
        let imageItem of _imageList | slice : _minIndex : _maxIndex;
        let i = indexImage
      "
    >
      <img
        matRipple
        (click)="fnShow(imageItem.indexImage)"
        src="{{ imageItem.urlImage }}"
        style="height: 54px; object-fit: cover; margin: 0px 0px -6.5px 0px"
      />
    </div>
  </div>
</div>
